import { device } from '@/utils/index'

const content = [
    // 第一章 第二节
    // 节标题
    {
        key: 'section3',
        type: "title",
        category: 2, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        shortText: "任务二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '绘制平面图形', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    // 小标题
    {
        key: 'section3.1.0',
        type: "title",
        category: 7, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: "任务引入", // *必填* 标题文本内容
        titleImage: require("@/assets/images/books/book1/title-back.png"),
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            textIndent: 80, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.1.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.1.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '机械零件的形状和结构虽然不尽相同，但其图样都是由直线、圆、圆弧和其他一些非圆曲线等几何图形组成的平面图形。熟练掌握绘制平面图形的基本技能，能够提高绘制机械图样的速度和质量。因此，某机械设计公司为了检验应聘制图岗位人员的基本技能，在面试时要求应聘人员现场绘制如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.1.1.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-18', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.1.1.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示的机械零件图形。学习本任务后，你能通过这项检验吗？', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.1.2', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.1.2.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-18机械零件图形.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-18<\/i>  机械零件图形", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section3.1.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.1.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '正确使用尺规绘图工具和熟练绘制常用几何图形是机械制图的基本技能，本任务将在介绍这些基本技能的基础上，讲解平面图形的分析与绘制方法，以及徒手绘图的方法。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 任务工单
    {
        key: 'section3.1.4', // *必填* 唯一标识
        type: 'workOrder', // *必填* 类型：任务工单
        title: '任务工单1.2——尺规绘图练习', // 标题
        content: [
            {
                key: 'section3.1.4.0',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '一、任务描述', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 48,
                },
            },
            {
                key: 'section3.1.4.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section3.1.4.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '正确使用尺规绘图工具和熟练绘制常用几何图形是机械制图的基础。支架类零件是最常用的机械零件之一，主要用于支承运动零件和其他零件。一种支架的机械图样如图', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section3.1.4.1.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section3.1.4.1.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '所示，请先观察其结构特点，然后选择合适的绘图比例和尺规绘图工具重新绘制。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 图片
            {
                key: 'section3.1.4.2', // *必填* 唯一标识
                type: 'image', // *必填* 类型：正文
                templateType: 1,
                content: [ // *必填* 图片列表
                    {
                        key: 'section3.1.4.2.1', // *必填* 唯一标识
                        url: require("@/assets/images/books/book1/workOrder/img-3.png"), // *必填* 图片地址
                        title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1<\/i>  一种支架的机械图样", // 图片标题
                        maxWidth: 544,
                        heightNoLimit: 1,
                        titleStyle: {

                        }
                    }
                ],
            },
            {
                key: 'section3.1.4.3',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '二、学生分组', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 48,
                },
            },
            {
                key: 'section3.1.4.4', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section3.1.4.4.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '以', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section3.1.4.4.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '5～6', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section3.1.4.4.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '人为一组，选出组长并进行任务分工，将小组概况及分工填入表', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section3.1.4.4.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section3.1.4.4.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 任务工单 表格1
            {
                key: 'section2.2.0.8',
                type: "workOrderTable1", // *必填* 类型：任务工单 表格1
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1<\/i> 小组概况及分工", // *必填* 标题文本内容
            },
            {
                key: 'section3.1.4.5',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '三、任务准备', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 48,
                },
            },
            {
                key: 'section3.1.4.5.1',
                type: "title",
                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '1．获取信息', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 10,
                },
            },
            {
                key: 'section3.1.4.5.2', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section3.1.4.5.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '在进行尺规绘图练习之前，需要熟悉尺规绘图工具的基本知识、常用几何图形的画法，以及平面图形的分析与绘制方法。请各组组长组织组员收集有关资料，回答下列问题。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 任务工单 答题
            {
                key: 'section3.1.4.5.3',
                type: "workOrderQuestion", // *必填* 类型：任务工单 答题
                content: [
                    {
                        key: 'section3.1.4.5.3.1',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.2',
                        type: 'completion',
                        content: [
                            {
                                key: 'section3.1.4.5.3.1.1',
                                type: 'text',
                                text: '尺规绘图是指用图板、'
                            },
                            {
                                key: 'section3.1.4.5.3.1.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.1.3',
                                type: 'text',
                                text: '、'
                            },
                            {
                                key: 'section3.1.4.5.3.1.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.1.5',
                                type: 'text',
                                text: '、分规、'
                            },
                            {
                                key: 'section3.1.4.5.3.1.6',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.1.7',
                                type: 'text',
                                text: '、图纸等绘图工具与仪器来绘制图样。'
                            },
                        ]
                    },
                    {
                        key: 'section3.1.4.5.3.2',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.2',
                        type: 'completion',
                        content: [
                            {
                                key: 'section3.1.4.5.3.2.1',
                                type: 'text',
                                text: '图板主要用于铺放和固定'
                            },
                            {
                                key: 'section3.1.4.5.3.2.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.2.3',
                                type: 'text',
                                text: '，三角板用于画出与'
                            },
                            {
                                key: 'section3.1.4.5.3.2.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.2.5',
                                type: 'text',
                                text: '成多个角度的直线，圆规用于画'
                            },
                            {
                                key: 'section3.1.4.5.3.2.6',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.2.7',
                                type: 'text',
                                text: '和'
                            },
                            {
                                key: 'section3.1.4.5.3.2.8',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.2.9',
                                type: 'text',
                                text: '，分规用于'
                            },
                            {
                                key: 'section3.1.4.5.3.2.10',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.2.11',
                                type: 'text',
                                text: '、'
                            },
                            {
                                key: 'section3.1.4.5.3.2.12',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.2.13',
                                type: 'text',
                                text: '和'
                            },
                            {
                                key: 'section3.1.4.5.3.2.14',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.2.15',
                                type: 'text',
                                text: '。'
                            },
                        ]
                    },
                    {
                        key: 'section3.1.4.5.3.3',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.2.13',
                        type: 'completion',
                        content: [
                            {
                                key: 'section3.1.4.5.3.3.1',
                                type: 'text',
                                text: '在机械制图中，绘制底稿时用'
                            },
                            {
                                key: 'section3.1.4.5.3.3.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.3.3',
                                type: 'text',
                                text: '或'
                            },
                            {
                                key: 'section3.1.4.5.3.3.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.3.5',
                                type: 'text',
                                text: '绘图铅笔，描深加粗图线时用'
                            },
                            {
                                key: 'section3.1.4.5.3.3.6',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.3.7',
                                type: 'text',
                                text: '或'
                            },
                            {
                                key: 'section3.1.4.5.3.3.8',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.3.9',
                                type: 'text',
                                text: '绘图铅笔，写字和画箭头时用'
                            },
                            {
                                key: 'section3.1.4.5.3.3.10',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.3.11',
                                type: 'text',
                                text: '绘图铅笔。'
                            },
                        ]
                    },
                    {
                        key: 'section3.1.4.5.3.4',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.3.29',
                        type: 'completion',
                        content: [
                            {
                                key: 'section3.1.4.5.3.4.1',
                                type: 'text',
                                text: '在机械图样上，斜度和锥度通常以“'
                            },
                            {
                                key: 'section3.1.4.5.3.4.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.4.3',
                                type: 'text',
                                text: '”的比例形式进行标注，并在比例前加斜度或锥度符号，斜度和锥度符号中'
                            },
                            {
                                key: 'section3.1.4.5.3.4.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.4.5',
                                type: 'text',
                                text: '的倾斜方向应与斜度或锥度方向相一致。'
                            },
                        ]
                    },
                    {
                        key: 'section3.1.4.5.3.5',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.3.45',
                        type: 'completion',
                        content: [
                            {
                                key: 'section3.1.4.5.3.5.1',
                                type: 'text',
                                text: '根据作用的不同，平面图形的尺寸可分为定形尺寸和定位尺寸两种。其中，定形尺寸用于确定平面图形中各部分'
                            },
                            {
                                key: 'section3.1.4.5.3.5.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.5.3',
                                type: 'text',
                                text: '的大小，定位尺寸用于确定平面图形中各部分之间的'
                            },
                            {
                                key: 'section3.1.4.5.3.5.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.5.5',
                                type: 'text',
                                text: '。'
                            },
                        ]
                    },
                    {
                        key: 'section3.1.4.5.3.6',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.3.49',
                        type: 'completion',
                        content: [
                            {
                                key: 'section3.1.4.5.3.6.1',
                                type: 'text',
                                text: '绘制平面图形时，应在'
                            },
                            {
                                key: 'section3.1.4.5.3.6.2',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.6.3',
                                type: 'text',
                                text: '的基础上进行线段分析，从而确定各图线的绘制顺序：先画'
                            },
                            {
                                key: 'section3.1.4.5.3.6.4',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.6.5',
                                type: 'text',
                                text: '，再画'
                            },
                            {
                                key: 'section3.1.4.5.3.6.6',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.6.7',
                                type: 'text',
                                text: '，最后画'
                            },
                            {
                                key: 'section3.1.4.5.3.6.8',
                                type: 'input',
                                text: ''
                            },
                            {
                                key: 'section3.1.4.5.3.6.9',
                                type: 'text',
                                text: '。'
                            },
                        ]
                    },
                    {
                        key: 'section3.1.4.5.3.7',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.3.25.99',
                        type: 'shortAnswer',
                        questionText: '简述用圆弧光滑连接锐角或钝角的两边的作图步骤。',
                        answer: ''
                    },
                    {
                        key: 'section3.1.4.5.3.8',
                        guideChapter: 'chapter1sub2',
                        guide: 'section3.3.27',
                        type: 'shortAnswer',
                        questionText: '简述用圆弧光滑连接两条圆弧（内连接）的作图步骤。',
                        answer: ''
                    },
                ],
                textStyle: {},
            },
            {
                key: 'section2.2.0.9.5',
                type: "title",
                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '2．制订计划', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 30,
                },
            },
            {
                key: 'section2.2.0.9.6', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.6.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '查阅有关资料，了解绘制平面图形的方法和步骤，制订实施计划。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.9.7',
                type: "title",
                category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '3．进行决策', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 20,
                },
            },
            {
                key: 'section2.2.0.9.8', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.8.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.9.8.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.9.8.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）每位学生阐述自己的计划。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.9.9', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.9.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.9.9.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.9.9.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）组员之间进行提问与答疑，制订本组的最佳实施计划。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.9.10', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.9.10.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.9.10.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '3', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.9.11.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）教师根据各组完成情况进行点评。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            {
                key: 'section2.2.0.10',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '四、任务实施', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 20,
                },
            },
            {
                key: 'section2.2.0.10.1', // *必填* 唯一标识
                type: 'text', // *必填* 类型：正文
                content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                    {
                        key: 'section2.2.0.10.1.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '按照实施计划进行尺规绘图练习。按实际实施过程，将实施步骤、遇到的问题及解决办法等全部记录于表', // *必填* 文本内容
                        textStyle: {},
                    },
                    {
                        key: 'section2.2.0.10.1.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2', // *必填* 文本内容
                        textStyle: {
                            fontFamily: 'Times New Roman', // 字体，本地配置的字体
                        },
                    },
                    {
                        key: 'section2.2.0.10.1.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中。', // *必填* 文本内容
                        textStyle: {},
                    },
                ],
                textStyle: {
                    textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
                    color: '#333', // 文本颜色  默认：#00a8ac
                },
            },
            // 任务工单 表格2
            {
                key: 'section2.2.0.10.2',
                type: "workOrderTable2", // *必填* 类型：任务工单 表格1
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">2<\/i>  工作实施过程记录表", // *必填* 标题文本内容
            },
            {
                key: 'section2.2.0.11',
                type: "title",
                category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
                text: '五．任务小结', // *必填* 标题文本内容
                textStyle: {
                    marginTop: 20,
                },
            },
            {
                key: 'section2.2.0.11.1',
                type: "formTextarea",
            },
        ]
    },
    // 标题
    {
        key: 'section3.2',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '一、常用尺规绘图工具及其使用', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '尺规绘图是指用图板、丁字尺、三角板、圆规、分规、绘图铅笔、图纸等绘图工具与仪器来绘制图样。虽然在工程实践中用计算机辅助设计软件绘图已经普及，但尺规绘图仍然是工程技术人员必备的基本技能，也是学习和掌握绘图基本知识和基本技能的必要途径。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.2.2',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．图板与丁字尺', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '图板主要用于铺放和固定图纸，其左短边为工作边，称为导边。丁字尺由尺头和尺身两部分组成，尺头右边和尺身上边为工作边。绘图时，应先将图纸用胶带固定在图板上，然后将丁字尺的尺头右边紧靠图板的导边，上下滑动丁字尺至画线位置，左手按住丁字尺尺身，即可用绘图铅笔沿尺身上边由左向右画出水平线，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-19', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.2.4', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.2.4.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-19图板与丁字尺配合画线.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-19<\/i>  图板与丁字尺配合画线", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.2.4.11',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．三角板', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.5', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '一副三角板有两块，一块两角均为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '45°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，另一块两角分别为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '30°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '60°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '。三角板与丁字尺配合使用，可画出与水平线成多个角度的直线，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-20', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。此外，这两块三角板配合使用，不仅可以画出与已知直线成', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '15°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '及其整数倍角度的直线，还可以画出已知直线的平行线，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-20', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.5.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'b', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.5.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.2.6', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.2.6.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-20三角板的用法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-20<\/i>   三角板的用法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.2.7',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '3．圆规', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.8', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.8.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '圆规是用于画圆和圆弧的工具，它的两脚分别为固定针脚和可以装铅笔插件、鸭嘴笔插件及延伸杆的活动脚，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.8.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-21', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.8.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.2.9', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.2.9.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-21圆规及其附件.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-21<\/i>   圆规及其附件", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section3.2.10', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.10.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '用圆规绘图前，应将固定针脚的钢针有台阶的一端朝下，并调整钢针和活动脚上铅芯的伸出长度，使钢针台阶面与铅芯尖（或鸭嘴尖）在圆规两脚并拢时平齐，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.10.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-22', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.10.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.10.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.10.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。用圆规绘图时，应将圆规按顺时针方向旋转，并保证钢针与铅芯在旋转过程中均垂直于纸面，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.10.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-22', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.10.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.10.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'b', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.10.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。画大圆时，应在圆规的活动脚上加装延伸杆，并使钢针与铅芯均垂直于纸面，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.10.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-22', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.10.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.10.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'c', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.10.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.2.91', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.2.91.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-22圆规及其附件.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-22<\/i>   圆规及其附件", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.2.101',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '4．分规', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.11', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.11.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '分规是用于量取尺寸、截取线段和等分线段的工具。使用分规前，应检查分规两脚的针尖在两脚并拢时是否平齐。分规的用法如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.11.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-23', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.11.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.2.12', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.2.12.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-23分规的用法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-23<\/i>   分规的用法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.2.13',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '5．绘图铅笔', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.14', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.14.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '根据铅芯的软硬程度不同，绘图铅笔可分为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H、HB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '三种规格。其中，', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '代表硬质绘图铅笔，', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '前的数字越大，表示铅芯越硬，所画图线的颜色越浅；', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'HB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '代表软硬适中的绘图铅笔；', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '代表软质铅笔，', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '前的数字越大，表示铅芯越软，所画图线的颜色越深。在机械制图中，绘制底稿时用', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '或', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.18', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.19', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '绘图铅笔，描深加粗图线时用', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.20', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.21', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '或', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.22', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.23', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '绘图铅笔，写字和画箭头时用', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.14.24', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'HB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.14.25', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '绘图铅笔。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 小互动
    {
        key: 'section3.2.15',
        type: 'frame',
        category: 'frame_interact',
        titleBg: {
            src: require("@/assets/images/books/book1/frame_interate_titlebg.png"),
            textStyle: {},
        },
        content: [
            // 交互 拼图/组装
            {
                key: 'section3.2.15.1', // *必填* 唯一标识
                type: 'action', // *必填* 类型：交互
                actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                title: '请点击下方两张图上的红框，在弹出的选项中选择正确的选项。', // 标题
                titleStyle: {},
                isInBlock: 1,
                content: [
                    {
                        // 拼图/组装
                        key: 'section3.2.15.1.1', // *必填* 唯一标识
                        actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                        cover: require("@/assets/images/books/book1/action/jigsaw-back-4.png"),
                        title: '绘制底稿',
                        width: 600,
                        height: 250,
                        content: [
                            {
                                top: 56,
                                left: 445,
                                width: 104,
                                height: 63,
                                hideBack: 1,
                                hideCenterPoint: 1,
                                answerPosition: 'left', // 答案显示位置
                                answerInBlock: 1,
                                answerKey: ['key1', 'key2'],
                                radioPosition: 'left'
                            },
                        ],
                        options: [
                            {
                                value: 'key1',
                                label: '3H',
                            },
                            {
                                value: 'key2',
                                label: '2H',
                            },
                            {
                                value: 'key3',
                                label: '2B',
                            },
                            {
                                value: 'key4',
                                label: 'B',
                            },
                            {
                                value: 'key5',
                                label: 'HB',
                            },
                        ],
                    },
                    {
                        // 拼图/组装
                        key: 'section3.2.15.1.2', // *必填* 唯一标识
                        actionType: 4, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
                        cover: require("@/assets/images/books/book1/action/jigsaw-back-5.png"),
                        title: '描深加粗、标注尺寸绘制底稿',
                        width: 600,
                        height: 398,
                        content: [
                            {
                                top: 35,
                                left: 498,
                                width: 97,
                                height: 59,
                                hideBack: 1,
                                hideCenterPoint: 1,
                                answerPosition: 'top',
                                answerInBlock: 1,
                                answerKey: 'key5',
                                radioPosition: 'left'
                            },
                            {
                                top: 134,
                                left: 498,
                                width: 97,
                                height: 59,
                                hideBack: 1,
                                hideCenterPoint: 1,
                                answerPosition: 'left',
                                answerInBlock: 1,
                                answerKey: ['key3', 'key4'],
                                radioPosition: 'left'
                            },
                            {
                                top: 335,
                                left: 233,
                                width: 97,
                                height: 59,
                                hideBack: 1,
                                hideCenterPoint: 1,
                                answerPosition: 'left',
                                answerInBlock: 1,
                                answerKey: 'key5'
                            },
                        ],
                        options: [
                            {
                                value: 'key1',
                                label: '3H',
                            },
                            {
                                value: 'key2',
                                label: '2H',
                            },
                            {
                                value: 'key3',
                                label: '2B',
                            },
                            {
                                value: 'key4',
                                label: 'B',
                            },
                            {
                                value: 'key5',
                                label: 'HB',
                            },
                        ],
                    },
                ]
            },
        ]
    },
    //正文
    {
        key: 'section3.2.16', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.16.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为了保证同一图样上同类图线的线宽一致，画粗实线时，绘图铅笔的铅芯应磨削成截面为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.16.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'dxd', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.16.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.16.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'd', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.16.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为粗线的线宽）的四棱柱形；绘制底稿及写字时，铅芯应削成锥形；画线时，绘图铅笔与画线方向的夹角应为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.16.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '60°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.16.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '左右，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.2.16.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-24', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.2.16.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。此外，削绘图铅笔时应从没有规格标记的一端开始，保留有规格标记的一端，以便识别绘图铅笔的规格。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.2.17', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.2.17.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-24绘图铅笔的削制形状和使用方法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-24<\/i>   绘图铅笔的削制形状和使用方法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
   //点拔
  {
    key: 'section3.2.18',
    type: "frame",
    shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: '', // *必填* 标题文本内容
    category: 'frame_section',//
    titleBg: { 
      key: 'section3.2.18.1', // *必填* 唯一标识
      src: require("@/assets/images/books/book1/frame_give_titlebg.png"), // *必填* 图片地址
      category: 'frame_titlebg',
      textStyle: {
        width: '100%',
        height: 47,
      },
    },
    content: [
      {
        key: 'section3.2.18.2', // *必填* 唯一标识
        category: 'frame_cxtd',
        // text: '通常情况下，绘图铅笔铅芯的软硬程度可根据其粗细来识别：铅芯越粗，说明其越软；反之，铅芯越细，说明其越硬。绘图时，画圆弧的铅芯通常比画直线的铅芯软一些，以保证图线的颜色深度相一致。',
        textStyle: {
          color: '#1A1A1A',
          fontSize: device.isMobile ? 26 : 18,
          lineHeight: 44,
          textIndent: 40,
          fontFamily: 'SimSun',
          fontWeight: 400
        },
        fontContent:[
          {
            key: 'section3.2.18.3', // *必填* 唯一标识
            category: 'text',
            text: '通常情况下，绘图铅笔铅芯的软硬程度可根据其粗细来识别：铅芯越粗，说明其越软；反之，铅芯越细，说明其越硬。绘图时，画圆弧的铅芯通常比画直线的铅芯软一些，以保证图线的颜色深度相一致。',
            textStyle:{
              color: '#1A1A1A',
              fontSize: device.isMobile ? 26 : 18,
              textIndent: 40,
              fontFamily: 'SimSun',
              fontWeight:'bold'
            }
           }
        ]
      },
    ]
  },
    // 标题
    {
        key: 'section3.2.19',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '6．图纸', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.20', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.20.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '图纸应洁白、坚韧，用橡皮擦拭不易起毛，且符合国家规定的图幅尺寸要求。绘图时，应使用图纸的正面。识别图纸正反面时，用橡皮用力擦拭几下，不易起毛的一面即为正面。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.2.21', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.2.21.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '固定图纸时，将丁字尺尺头右边紧靠图板导边，以丁字尺尺身上边为基准将图纸摆正，然后绷紧图纸，用胶带将其固定在图板上。当图幅不大时，图纸宜固定在图板左下方，但在图纸下方应留出足够放置丁字尺的空间。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.3.0',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '二、常用几何图形的画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.1', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.3.1.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '平面图形是由若干几何图形组成的，而几何图形是指用几何作图方法画出的直线、圆弧和非圆曲线等。因此，熟练掌握常用几何图形的画法是快速、准确绘制平面图形的基础。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.3.2',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．等分线段的画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.3', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.3.3.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '画等分线段可采用辅助平行线法。如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.3.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-25', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

            {
                key: 'section3.3.3.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，要将已知线段', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.3.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.3.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '进行五等分，作图步骤如下。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.4', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.3.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.4.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

            {
                key: 'section3.3.4.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）过线段', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.4.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.4.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的端点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.4.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.4.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，作任意一条与原线段及其延长线不重合的射线', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.4.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AC。', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.5', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.3.5.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.5.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

            {
                key: 'section3.3.5.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）用直尺或圆规以点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.5.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.5.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为起点，在射线', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.5.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AC', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.5.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '上以适当长度截取五个等分点。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.6', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.3.6.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.6.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

            {
                key: 'section3.3.6.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）用直线连接点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.6.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.6.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '与点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.6.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.6.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，然后过其他各等分点分别作线段', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.6.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.6.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的平行线，这些平行线与线段', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.6.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.6.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的交点即为线段', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.6.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AB', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.6.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的等分点。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.7', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.7.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-25等分线段AB.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-25<\/i>   等分线段AB", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.3.8',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．等分圆的画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.9', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.3.9.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.9.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）将圆三、四、六等分', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.10', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.10.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '三角板与丁字尺配合使用，可将圆三、四、六等分，其作图方法如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.10.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-26', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.10.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.10.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.10.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）～（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.10.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'c', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.10.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。此外，也可利用圆的半径R将圆六等分，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.10.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-26', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.10.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.10.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'd', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.10.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示；用直线连接圆的六个等分点，可得到圆的内接正六边形。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.11', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.11.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-26将圆三、四、六等分.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-26<\/i>   将圆三、四、六等分", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section3.3.12', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section3.3.12.1', // *必填* 唯一标识
                url: require("@/assets/video/图1-26动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '图1-26 动画', // 视频标题
                subtitle: '图1-26 动画', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    //正文
    {
        key: 'section3.3.13', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项

            {
                key: 'section3.3.13.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.13.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）将圆五等分', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.14', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一
            {
                key: 'section3.3.14.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '已知圆的半径，可用圆规将圆五等分，然后用直线连接各等分点，即可得到圆的内接正五边形，具体作图步骤如下。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.15', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一
            {
                key: 'section3.3.15.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）如图1-27（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示，以圆的象限点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为圆心、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'OA', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为半径画圆弧，交圆于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'E', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'F', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，连接', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'EF', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '交直线', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'OA', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.15.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.15.18', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B。', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.16', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一
            {
                key: 'section3.3.16.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.16.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.16.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）如图1-27（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.16.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'b', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.16.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示，以点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.16.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.16.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为圆心、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.16.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'BC', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.16.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为半径画圆弧，交直线', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.16.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'OA', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.16.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.16.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'D。', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.17', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一
            {
                key: 'section3.3.17.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）如图1-27（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'c', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示，以点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'C', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为圆心，', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'CD', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为半径画圆弧，交圆于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'G', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '；然后分别以点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'G', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为圆心、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.18', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'CG', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.19', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.20', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'CH', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.21', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为半径画圆弧，交圆于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.22', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'M', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.17.23', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.17.24', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'N。', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.18', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一
            {
                key: 'section3.3.18.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'C', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'G', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'M', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'N', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '即为圆的五等分点，依次连接各等分点即可得到正五边形，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-27', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.18.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'd', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.18.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.19', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.19.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-27将圆五等分并画正五边形.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-27<\/i>   将圆五等分并画正五边形", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section3.3.20', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section3.3.20.1', // *必填* 唯一标识
                url: require("@/assets/video/图1-27动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '图1-27 动画', // 视频标题
                subtitle: '图1-27 动画', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    // 标题
    {
        key: 'section3.3.21',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '3．圆（或圆弧）切线的画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.22', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.22.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '在绘图过程中，经常会遇到作已知圆（或圆弧）', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.22.2', // *必填* 唯一标识
                category: 'popover', // *必填* 内容类型 text：文本
                text: '切线', // *必填* 文本内容
                popTitle: '切线的名词解释',
                popText: '几何上，切线指的是一条刚好触碰到曲线上某一点的直线。更准确地说，当切线经过曲线上的某点（即切点）时，切线的方向与曲线上该点的方向是相同的。平面几何中，将和圆只有一个公共交点的直线叫做圆的切线。',
                textStyle: {

                },
            },
            {
                key: 'section3.3.22.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的问题，解决该问题的关键是准确找出直线与圆（或圆弧）的切点。圆切线的画法如表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.22.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-6', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.22.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.23', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.23.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-6圆切线的画法.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-6<\/i>   圆切线的画法", // 图片标题
                // hasBack: 1,
                heightNoLimit: 1,
                titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.3.24',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '4．圆弧连接的画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.25', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.25.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '圆弧连接是指用圆弧光滑连接已知直线或曲线。为确保连接光滑，在画连接圆弧前，应准确画出连接圆弧的圆心和连接点（即切点）。常见的圆弧连接有用圆弧光滑连接两条直线、用圆弧光滑连接两条圆弧两种，其画法分别如表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.25.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-7', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.25.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和表', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.25.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-8', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.25.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.25.99', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.25.99.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-7用圆弧光滑连接两条直线的画法.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-7<\/i>   用圆弧光滑连接两条直线的画法", // 图片标题
                // hasBack: 1,
                heightNoLimit: 1,
                titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section3.3.26', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section3.3.26.1', // *必填* 唯一标识
                url: require("@/assets/video/表1-7动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '表1-7 动画', // 视频标题
                subtitle: '表1-7 动画', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    // 图片
    {
        key: 'section3.3.27', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.27.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-8用圆弧光滑连接两条圆弧的画法.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-8<\/i>   用圆弧光滑连接两条圆弧的画法", // 图片标题
                // hasBack: 1,
                heightNoLimit: 1,
                titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section3.3.28', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section3.3.28.1', // *必填* 唯一标识
                url: require("@/assets/video/表1-8动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '表1-8 动画', // 视频标题
                subtitle: '表1-8 动画', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    // 标题
    {
        key: 'section3.3.29',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '5．斜度与锥度的画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.30', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.30.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '斜度符号和锥度符号如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.30.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-28', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.30.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，其中', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.30.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'h', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.30.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为字体高度，符号线宽为', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.30.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'h', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.30.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '/10。', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.31', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.31.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-28斜度符号和锥度符号.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-28<\/i>   斜度符号和锥度符号", // 图片标题
                hasBack: 1,
                //heightNoLimit: 1,
                // titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section3.3.32', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.32.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '斜度是指直线或平面对另一直线或平面的倾斜程度，其大小用直线或平面与另一直线或平面之间夹角的正切值来表示。在机械图样上，斜度通常以“', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.32.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1∶', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.32.223', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'n', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.32.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”的比例形式进行标注，并在比例前加斜度符号，斜度符号中斜线的倾斜方向应与斜度方向相一致，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.32.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-29', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.32.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            }

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.33', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.33.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-29斜度的标注及画法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-29<\/i>   斜度的标注及画法", // 图片标题
                hasBack: 1,
                //heightNoLimit: 1,
                // titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    //正文
    {
        key: 'section3.3.34', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.34.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '锥度是指正圆锥的底圆直径', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.34.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'D', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.34.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '与高度', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.34.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.34.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '之比，或圆台的两底圆直径之差（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.34.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'D-d', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.34.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）与高度', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.34.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'H', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.34.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '之比。锥度也以“', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.34.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1∶', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.34.101', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'n', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.34.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '”的比例形式进行标注，并在比例前加锥度符号，锥度符号中斜线的倾斜方向应与锥度方向一致，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.34.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-30', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.34.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.35', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.35.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-30锥度的标注及画法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-30<\/i>   锥度的标注及画法", // 图片标题
                hasBack: 1,
                //heightNoLimit: 1,
                // titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.3.36',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "一", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '6．椭圆的近似画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.37', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.37.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '椭圆有两条相互垂直且各自对称的轴，即长轴和短轴。椭圆的近似画法一般为四心圆法。例如，已知椭圆的长轴', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.37.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AB', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.37.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和短轴', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.37.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'CD', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.37.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，其作图步骤如下。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.38', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.38.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）用直线连接长轴和短轴的端点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'C', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，得线段', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AC', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '；然后以点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'O', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为圆心、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'OA', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为半径画圆弧，与短轴交于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'E', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    verticalAlign: 'sub', // super：上标 sub：下标
                    fontSize: 10,
                },
            },
            {
                key: 'section3.3.38.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '；接着以点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'C', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.18', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为圆心、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.19', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'CE', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.20', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    verticalAlign: 'sub', // super：上标 sub：下标
                    fontSize: 10,
                },
            },
            {
                key: 'section3.3.38.21', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为半径画圆弧，交', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.22', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AC', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.23', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.24', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'E', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.25', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.26', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-31', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.27', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.38.28', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'a', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.38.29', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.39', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.39.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）作', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AE', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的中垂线，与', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AB', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'CD', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '分别交于点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '；接着分别以', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'AB', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '和', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'CD', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.18', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为对称中心线作这两点的对称点（点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.19', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

            {
                key: 'section3.3.39.21', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.22', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.23', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '），如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.24', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-31', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.25', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.39.26', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'b', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.39.27', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.40', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.40.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）分别以点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、点', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为圆心并以', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'A', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'C', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.141', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.18', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'B', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.142', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '、', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.19', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '4', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.20', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'D', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.21', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '为半径画圆弧，可得近似椭圆，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.22', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-31', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.23', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.40.24', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'c', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.25', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）所示。', // *必填* 文本内容
                textStyle: {},
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.41', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.41.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-31使用四心圆法画椭圆.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-31<\/i>   使用四心圆法画椭圆", // 图片标题
                hasBack: 1,
                //heightNoLimit: 1,
                // titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section3.3.42', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section3.3.42.1', // *必填* 唯一标识
                url: require("@/assets/video/图1-31动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '图1-31 动画', // 视频标题
                subtitle: '图1-31 动画', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    // 标题
    {
        key: 'section3.3.43',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '三、平面图形的分析与绘制', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.44', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.44.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '平面图形由若干线段（直线或圆弧）连接而成，这些线段之间的相对位置和连接关系依靠给定尺寸来确定。只有通过分析给定尺寸和线段之间的关系，才能明确平面图形应从何处着手并按何种顺序作图。', // *必填* 文本内容
                textStyle: {},
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.3.45',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．尺寸分析', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.46', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.46.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.46.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-32', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，手柄平面图中的尺寸根据其作用的不同可分为定形尺寸和定位尺寸两种。其中，定形尺寸用于确定平面图形中各部分几何形状的大小，如确定线段的长度、圆弧的半径（或圆的直径）和角度的大小等，如图中的', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.46.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '15、', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '10、', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '12、', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '15、', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'EUCSYMBI', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'EUCSYMBI', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '20', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '等，都是定形尺寸；定位尺寸用于确定平面图形中各部分之间的相对位置，如图中的', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.40.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '8', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '确定了', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.40.18', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'EUCSYMBI', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.40.19', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '5', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.20', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的圆心位置，', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.40.21', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '75', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.22', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '间接确定了', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.46.23', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.24', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '10', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.25', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '的圆心位置，', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.46.26', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '45', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.27', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '确定了', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.46.28', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.29', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '50', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.46.30', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '圆心的一个坐标值。', // *必填* 文本内容
                textStyle: {

                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.47', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.47.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-32手柄平面图.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-32<\/i>   手柄平面图", // 图片标题
                hasBack: 1,
                //heightNoLimit: 1,
                // titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 三维模型
    {
        key: 'section3.3.471', // *必填* 唯一标识
        type: '3DModel', // *必填* 类型：音频
        title: '三维模型', // 标题
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 音频列表
            {
                key: 'section3.3.471.1', // *必填* 唯一标识
                url: 'https://code.bjjqe.net/2/2/15/jxztycad-sys/1-2-7.htm', // *必填* 地址
                cover: require("@/assets/images/books/bookExample/introduction/threeD-cover-1.png"), // 封面
                title: '图1-32 三维模型', // 标题
                titleStyle: {

                }
            },
        ]
    },
    // // 三维模型
    // {
    //     key: 'section3.3.48', // *必填* 唯一标识
    //     type: '3DModel', // *必填* 类型：音频
    //     title: '三维模型', // 标题
    //     styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
    //     // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
    //     // cover: require("@/assets/images/bookContent/single_video.png"),
    //     content: [ // *必填* 音频列表
    //         {
    //             key: 'section3.3.48.1', // *必填* 唯一标识
    //             url: 'http://code.bjjqe.net/2/2/15/jxztycad-sys/1-2-7.htm', // *必填* 地址
    //             cover: require("@/assets/images/books/bookExample/introduction/threeD-cover-1.png"), // 封面
    //             title: '这是点4545拨占位', // 标题
    //             titleStyle: {

    //             }
    //         },
    //     ]
    // },
    //点拔
    {
        key: 'section3.3.48',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_section', //
        titleBg: {
            key: 'section3.3.48.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_give_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 47,
            },
        },
        content: [{
            key: 'section3.3.48.2', // *必填* 唯一标识
            category: 'frame_cxtd',
            // text: '通常情况下，绘图铅笔铅芯的软硬程度可根据其粗细来识别：铅芯越粗，说明其越软；反之，铅芯越细，说明其越硬。绘图时，画圆弧的铅芯通常比画直线的铅芯软一些，以保证图线的颜色深度相一致。',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 40,
                fontFamily: 'SimSun',
                fontWeight: 400
            },
            fontContent: [{
                key: 'section3.3.48.3', // *必填* 唯一标识
                category: 'text',
                text: '定位尺寸常以图形的对称中心线、回转体的轴线或某一轮廓线（较大的底面、端面、侧面等的投影）作为标注尺寸的起点，这个起点称为尺寸基准，如图',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.48.4', // *必填* 唯一标识
                category: 'text',
                text: '1-32',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.48.5', // *必填* 唯一标识
                category: 'text',
                text: '中的',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.48.6', // *必填* 唯一标识
                category: 'text',
                text: 'A',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.48.7', // *必填* 唯一标识
                category: 'text',
                text: '和',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.48.8', // *必填* 唯一标识
                category: 'text',
                text: 'B',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.48.9', // *必填* 唯一标识
                category: 'text',
                text: '。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
        ]
        }, ]
    },
    // 标题
    {
        key: 'section3.3.49',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．线段分析', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.50', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.50.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '在平面图形中，通常根据定位尺寸完整与否将线段分为已知线段、中间线段和连接线段三种。其中，两个定位尺寸齐全的线段称为已知线段，如图', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.50.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-32', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中的', // *必填* 文本内容
                textStyle: {},
            },
            {
                key: 'section3.3.50.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '15、', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '10；', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

            {
                key: 'section3.3.50.8', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '只有一个定位尺寸的线段称为中间线段，如图', // *必填* 文本内容
                textStyle: {

                },
            },

            {
                key: 'section3.3.50.9', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-32', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

            {
                key: 'section3.3.50.10', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中的', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.50.11', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.12', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '50；', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.13', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '没有定位尺寸的线段称为连接线段，如图', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.50.14', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-32', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.15', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '中的', // *必填* 文本内容
                textStyle: {

                },
            },
            {
                key: 'section3.3.50.16', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: 'R', // *必填* 文本内容
                textStyle: {
                    fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.50.17', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '12。', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.51', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.51.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '绘制手柄平面图中的圆弧时，有两个定位尺寸的圆弧可直接根据给定尺寸作出；缺少一个定位尺寸的圆弧，由于它总是和一个已知线段相连接，因此可利用其与相邻已知线段的连接关系（相切条件），用圆弧连接的作图方法作出；缺少两个定位尺寸的圆弧，需要借助其与相邻两条已知线段的连接关系（相切条件），用圆弧连接的作图方法作出。', // *必填* 文本内容
                textStyle: {},
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.52', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.52.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '综上所述，绘制平面图形时，应在尺寸分析的基础上进行线段分析，从而确定各图线的绘制顺序：先画已知线段，再画中间线段，最后画连接线段。', // *必填* 文本内容
                textStyle: {},
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //问题模块内容
    {
        key: 'section3.3.53',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_answer', 
        titleBg: {
            key: 'section3.3.53.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_issue_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 50,
            },
        },
        content: [{
                key: 'section3.3.53.2', // *必填* 唯一标识
                category: 'frame_cxtd',
                textStyle: {
                    color: '#333333',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    textIndent: 35,
                    fontFamily: 'Microsoft YaHei',
                    fontWeight: 'bold'
                },
                fontContent: [{
                        key: 'section3.3.53.2.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '在绘制平面图形时，为什么最后画连接线段？', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                            lineHeight: 44,
                            fontWeight: 'bold'
                        }
                    }
                ]
            },
            {
                key: 'section3.3.53.3', // *必填* 唯一标识
                category: 'frame_cxtd',
                textStyle: {
                    color: '#333333',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    textIndent: 40,
                    fontFamily: 'Microsoft YaHei',
                },
                fontContent: [{
                        key: 'section3.3.53.3.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '连接线段通常没有自己的定位尺寸，它们的位置和尺寸依赖于已知线段和中间线段。因此，最后绘制连接线段可以确保它们能够正确地连接到已有的图形元素上，完成整个图形的构建。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 26 : 18,
                        },
                    },
                ]
            },
        ]
    },

    // 标题
    {
        key: 'section3.3.54',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '3．绘图的方法和步骤', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    // 标题
    {
        key: 'section3.3.55',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1）准备工作', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.56', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.56.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '准备工作主要包括以下内容。', // *必填* 文本内容
                textStyle: {


                },
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.57', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.57.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.57.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.57.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）分析图形的尺寸与线段。', // *必填* 文本内容
                textStyle: {


                },
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.58', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.58.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.58.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.58.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）确定比例，选择图幅，固定图纸。', // *必填* 文本内容
                textStyle: {


                },
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.59', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.59.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.59.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.59.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）拟订具体的作图顺序。', // *必填* 文本内容
                textStyle: {


                },
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.3.591',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2）绘制底稿', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.60', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.60.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '绘制底稿的步骤如图', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.60.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-33', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.60.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {


                },
            },


        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.3.61', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.3.61.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-33绘制底稿的步骤.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-33<\/i>  绘制底稿的步骤", // 图片标题
                heightNoLimit: 1,
                // hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 视频
    {
        key: 'section3.3.62', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section3.3.62.1', // *必填* 唯一标识
                url: require("@/assets/video/图1-33动画.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '图1-33 动画', // 视频标题
                subtitle: '图1-33 动画', // 视频副标题 只在全部显示时使用
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    //正文
    {
        key: 'section3.3.63', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.63.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '绘制底稿时应注意以下事项。', // *必填* 文本内容
                textStyle: {


                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.64', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.64.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.64.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.64.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）应使用', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.64.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2H', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.64.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '或', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.64.6', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3H', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.64.7', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '铅笔，笔尖应经常修磨以保持尖锐。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.65', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.65.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.65.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.65.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）底稿上各种线型的图线均暂不分粗细，并要画得颜色很浅、线宽很小。', // *必填* 文本内容
                textStyle: {


                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.3.66',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '3）描深底稿', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.67', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.67.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '描深底稿的原则如下。', // *必填* 文本内容
                textStyle: {


                },
            }
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.68', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.68.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.68.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.68.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）先细后粗。一般应先描深全部虚线、细点画线及细实线等，再描深全部粗实线，这样既可保证图面干净、提高绘图效率，又可保证同类图线在全图中的线宽一致，还能保证不同类图线之间的线宽符合比例关系。', // *必填* 文本内容
                textStyle: {


                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.69', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.69.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.69.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '2', // *必填* 文本内容
                textStyle: {

                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.68.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）先曲后直。在描深同一种线型的图线（特别是粗实线）时，应先描深圆弧和圆，然后描深直线，以保证连接处圆滑，以及圆（或圆弧）和直线的颜色深度一致。', // *必填* 文本内容
                textStyle: {


                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.70', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.70.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '（', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.3.70.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '3', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.3.70.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '）先水平后竖斜。先用丁字尺自上而下画出全部相同线型的水平线，再用三角板自左向右画出全部相同线型的竖直线，最后画出倾斜的直线。', // *必填* 文本内容
                textStyle: {


                },
            },

        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    //点拔
    {
        key: 'section3.3.71',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_section', 
        titleBg: {
            key: 'section3.3.71.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_give_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 47,
            },
        },
        content: [{
            key: 'section3.3.71.2', // *必填* 唯一标识
            category: 'frame_cxtd',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 40,
                fontFamily: 'SimSun',
                fontWeight: 400
            },
            fontContent: [{
                key: 'section3.3.71.2.1', // *必填* 唯一标识
                category: 'text',
                text: '描深底稿时需要注意以下事项。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            }]
        },
        {
            key: 'section3.3.71.3', // *必填* 唯一标识
            category: 'frame_cxtd',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 40,
                fontFamily: 'SimSun',
                fontWeight:'bold'
            },
            fontContent: [
                {
                key: 'section3.3.71.3.1', // *必填* 唯一标识
                category: 'text',
                text: '① 在描深底稿前，必须全面检查底稿，清理图面，修正错误，把画错的图线及作图辅助线用软橡皮轻轻擦净。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
        ]
        },
        {
            key: 'section3.3.71.4', // *必填* 唯一标识
            category: 'frame_cxtd',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 40,
                fontFamily: 'SimSun',
                fontWeight: 400
            },
            fontContent: [
                {
                key: 'section3.3.71.4.1', // *必填* 唯一标识
                category: 'text',
                text: '② 用',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.71.4.2', // *必填* 唯一标识
                category: 'text',
                text: 'H、HB、B、2B ',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'Times New Roman',
                    fontWeight:'bold'
                }
            },
            {
                key: 'section3.3.71.4.3', // *必填* 唯一标识
                category: 'text',
                text: '等不同规格的铅笔描深各种图线，用力要均匀一致，以免图线的颜色深浅不一。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
        ]
        },
        {
            key: 'section3.3.71.5', // *必填* 唯一标识
            category: 'frame_cxtd',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 40,
                fontFamily: 'SimSun',
                fontWeight:'bold'
            },
            fontContent: [
                {
                key: 'section3.3.71.5.1', // *必填* 唯一标识
                category: 'text',
                text: '③ 为避免弄脏图面，要保持双手、三角板及丁字尺清洁。描深过程中应经常用毛刷将图纸上的铅芯粉末扫净，并尽量避免在已描深的图线上移动三角板。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
        ]
        },
        {
            key: 'section3.3.71.6', // *必填* 唯一标识
            category: 'frame_cxtd',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 40,
                fontFamily: 'SimSun',
                fontWeight: 400
            },
            fontContent: [
                {
                key: 'section3.3.71.6.1', // *必填* 唯一标识
                category: 'text',
                text: '④ 描深后的图线很难擦净，因此要尽量避免画错。需要擦掉时，可用软橡皮顺着图线的方向擦拭。',
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    textIndent: 40,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                }
            },
        ]
        },
    ]
    },
    // 标题
    {
        key: 'section3.3.72',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '4）标注尺寸', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.73', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.73.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '标注定形尺寸和定位尺寸，注写其他文字、符号，填写标题栏。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.3.74',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '5）检查、完善', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.3.75', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.3.75.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '全面检查、校订图纸，清理图面。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.4.1',
        type: "title",
        category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '四、徒手绘图', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.4.2', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.4.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '徒手绘图通常用于绘制草图，它不借助尺规绘图工具，而是通过目测估计物体各部分的尺寸比例来绘图的。徒手绘图可快速、准确地表达设计意图，或快速记录所需要的技术资料，因此在技术交流和现场测绘时应用很广。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 标题
    {
        key: 'section3.4.3',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '1．直线的徒手画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.4.4', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.4.4.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '徒手画直线时，可先标出直线的两个端点，然后悬肘执笔并沿直线方向比画一下，待掌握好画线方向和路径后再落笔画线。此时，铅笔落在起点，眼睛注视终点，以控制画线方向。为了运笔方便，在画水平线和竖直线时，可将图纸斜放；画水平线时，要自左至右运笔；画竖直线时，要自上而下运笔，如图', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.4.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-34', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.4.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.4.5', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.4.5.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-34水平线和竖直线的运笔方向及徒手画法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-34<\/i>  水平线和竖直线的运笔方向及徒手画法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.4.6',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '2．常用角度线的徒手画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.4.7', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.4.7.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '徒手画', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.7.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '30°、45°、60°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.7.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '等常见角度的角度线时，可根据直角边的比例关系，在两直角边上定出几点，然后连接这些点即可。角度线的运笔方向及徒手画法如图', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.7.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-35', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.7.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.4.8', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.4.8.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-35角度线的运笔方向及徒手画法.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-35<\/i>  角度线的运笔方向及徒手画法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.4.9',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '3．圆的徒手画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.4.10', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.4.10.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '如图', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.10.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-36', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.10.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，徒手画圆时，若圆的半径较小，则应先确定圆的位置并画出两条相互垂直的中心线，然后以目测估计的半径标记出圆在中心线上的四个点，最后将这四个点依次连接即可；若圆的半径较大，则除在中心线上标记四个点外，还应过圆心在', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.10.4', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '45°', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.10.5', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '方向上加画两条斜线，同样在这两条斜线上标记出四个点，最后将这八个点依次连接即可。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.4.11', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.4.11.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-36圆的徒手画法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-36<\/i>  圆的徒手画法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.4.12',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '4．椭圆的徒手画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.4.13', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.4.13.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '如图', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.13.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-37', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.13.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，徒手画椭圆时，应先画出椭圆两条相互垂直的长轴和短轴；然后在这两条轴线上分别选取椭圆的四个端点；接着过这四个端点画椭圆的外切矩形，并用标记将矩形的对角线六等分；最后将长、短轴的端点和对角线上靠外侧的等分点依次连接即可。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.4.14', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.4.14.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-37椭圆的徒手画法.jpg"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-37<\/i>  椭圆的徒手画法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // 标题
    {
        key: 'section3.4.15',
        type: "title",
        category: 4, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '5．圆角和连接圆弧的徒手画法', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.4.16', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.4.16.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '如图', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.16.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-38', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.16.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示，徒手画圆角和连接圆弧时，应先画角平分线；然后在角平分线上选取圆心，并过圆心画两条边的垂线，以指定圆弧的两个切点；接着在角平分线上以目测估计的半径选取圆弧上的一点；最后将这三个点依次连接起来即可。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.4.17', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.4.17.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/图1-38圆角和连接圆弧的徒手画法.png"), // *必填* 图片地址
                title: "图<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-38<\/i>  圆角和连接圆弧的徒手画法", // 图片标题
                hasBack: 1,
                //titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
    // {
    //     key: 'section3.4.18', // *必填* 唯一标识
    //     type: 'video', // *必填* 类型：视频
    //     templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
    //     styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
    //     content: [ // *必填* 视频列表
    //         {
    //             key: 'section3.1.4.1', // *必填* 唯一标识
    //             url: require("@/assets/video/图1-2动画.mp4"), // *必填* 视频地址
    //             left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
    //             title: '这是笔记占位', // 视频标题
    //             subtitle: '这是笔记占位', // 视频副标题 只在全部显示时使用
    //             titleStyle: {
                    
    //             }
    //         },
    //     ],
    // },
     //笔记内容
     {
        key: 'section3.4.18',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '文旌数字教材', // *必填* 标题文本内容
        category: 'frame_textarea', //
        titleBg: {
            key: 'section3.4.18.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_note_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 48,
            },
        },
        content: [{
            key: 'section3.4.18.2', // *必填* 唯一标识
            category: '',
            hasBack: 1, // 是否存在背景 背景默认为白色背景黑色描边 1：存在 2：不存在
            placeholder: '请输入你的笔记',
            value: '',
            titleStyle: {

            }
        }, ]
    },
    //任务实施2
  {
    key: 'section3.4.19',
    type: "taskEffect",
    shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: '', // *必填* 标题文本内容
    category: '',
    content: [
      {
        key: 'section3.4.19.1', // *必填* 唯一标识 
        category: '',
        text: '任务实施 —— 尺规绘图练习',
        isreset:false,//是否显示重置按钮
        popText:'机械零件的形状和结构虽然不尽相同，但其图样都是由直线、圆、圆弧和其他一些非圆曲线等几何图形组成的平面图形。熟练掌握绘制平面图形的基本技能，能够提高绘制机械图样的速度和质量。因此，某机械设计公司为了检验应聘制图岗位人员的基本技能，在面试时要求应聘人员现场绘制如图 1-18所示的机械零件图形。学习本任务后，你能通过这项检验吗？',
        textStyle: {
          color: '#0482EC',
          fontSize: 28,
          lineHeight: 48,
          fontFamily: 'Microsoft YaHei',
          fontWeight: 'bold'
        },
        
        image: {
          key: 'section3.4.19.2', // *必填* 唯一标识
          src: require("@/assets/images/books/book1/answer1-39.png"), // *必填* 图片地址
          category: 'image',
          style:{
            width:599,
            height:472
          },
          text:[
            {
              key: 'section3.4.19.2.1', // *必填* 唯一标识
              category: '',
              textStyle:{
               color:''
              }
            }
          ]
        },
        footertext:{
          key: 'section3.4.19.3', // *必填* 唯一标识
          category: 'text',
        //   text:'图1-39  作图步骤',
          textStyle:{
              color:'#666666',
              fontSize: device.isMobile ? 20 : 16,
              lineHeight:48,
              textAlign:'center',
              marginTop:26
          },
          fontContent:[
            {
                key: 'section3.4.19.3.1', // *必填* 唯一标识
                category: '',
                text: '图',
                textStyle: {
                    color: '#666666',
                    fontSize: device.isMobile ? 20 : 16,
                }
            },
            {
                key: 'section3.4.19.3.2', // *必填* 唯一标识
                category: '',
                text: '1-39',
                textStyle: {
                    color: '#666666',
                    fontSize: device.isMobile ? 20 : 16,
                    fontFamily: 'Times New Roman',
                }
            },
            {
                key: 'section3.4.19.3.3', // *必填* 唯一标识
                category: '',
                text: '作图步骤',
                textStyle: {
                    color: '#666666',
                    fontSize: device.isMobile ? 20 : 16,
                }
            },
          ]
        },
        answerContent:{
          key: 'section3.4.19.4', // *必填* 唯一标识
          src: require("@/assets/images/books/book1/1-39.png"), // *必填* 图片地址
          category: 'image',
          style:{
            width:500,
            height:386,
            marginTop:25
          },
        },
        list:[
            {
                key: 'section3.4.19.5', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.5.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '尺寸分析：', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontWeight: 'bold'
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.6', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.6.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '在图', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1-18', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中，长度', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '39', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '和高度', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.6', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '4、', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.7', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '直径', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.8', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '',
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'EUCSYMBI',
                        },
                    },
                    {
                        key: 'section3.4.19.6.9', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '7', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.10', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '和', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.11', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '',
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'EUCSYMBI',
                        },
                    },
                    {
                        key: 'section3.4.19.6.12', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '14', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.13', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '，以及圆弧半径', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.14', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'R9、R12、R15、R25', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.15', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '都是定形尺寸；长度', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.16', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '34', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.17', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '和高度', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.6.18', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '24', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.6.19', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '为定位尺寸。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.7', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.7.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '线段分析：', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontWeight: 'bold'
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.8', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.8.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '在图', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1-18', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '中，长度为', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '39', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '和', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.6', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '4', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.7', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '的直线、直径为', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.8', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '',
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'EUCSYMBI',
                        },
                    },
                    {
                        key: 'section3.4.19.8.9', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '7', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.10', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '和', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.11', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '',
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'EUCSYMBI',
                        },
                    },
                    {
                        key: 'section3.4.19.8.12', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '14', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.13', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '的圆为已知线段，半径为', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.14', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'R19', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.15', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '和', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.16', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'R15', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.17', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '的圆弧为中间线段，半径为', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.18', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'R12', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.19', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '和', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.8.20', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'R25', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.8.21', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '的圆弧为连接线段。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.9', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.9.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '作图步骤：', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontWeight: 'bold'
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.10', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.10.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.10.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.10.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）画出已知线段，如图', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.10.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1-39', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.10.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.10.6', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'a', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.10.7', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）所示。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.11', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.11.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.11.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '2', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.11.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）画出中间线段，如图', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.11.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1-39', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.11.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.11.6', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'b', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.11.7', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）所示。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.12', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.12.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.12.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '3', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.12.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）画出连接线段。首先确定连接线段的圆心，然后连接相应圆心确定切点，最后画出连接线段，如图', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.12.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1-39', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.12.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.12.6', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: 'c', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.12.7', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）所示。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                ]
            },
            {
                key: 'section3.4.19.13', // *必填* 唯一标识
                type: 'text',
                listtContent: [{
                        key: 'section3.4.19.13.1', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '（', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.13.2', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '4', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.13.3', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '）擦去多余图线并标注尺寸，便可得到如图', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                    {
                        key: 'section3.4.19.13.4', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '1-18', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                            fontFamily: 'Times New Roman',
                        },
                    },
                    {
                        key: 'section3.4.19.13.5', // *必填* 唯一标识
                        category: 'text', // *必填* 内容类型 text：文本
                        text: '所示的图形。', // *必填* 文本内容
                        textStyle: {
                            color: '#333333',
                            fontSize: device.isMobile ? 28 : 18,
                            textIndent: 40,
                        },
                    },
                ]
            },
        ]
      },
    ]
  },
    //创想天地
    {
        key: 'section3.4.20',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '', // *必填* 标题文本内容
        category: 'frame_section', //
        titleBg: {
            key: 'section3.4.20.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_cxtd_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 66,
            },
        },
        content: [{
            key: 'section3.4.20.2', // *必填* 唯一标识
            category: 'frame_cxtd',
            textStyle: {
                color: '#1A1A1A',
                fontSize: device.isMobile ? 26 : 18,
                lineHeight: 44,
                textIndent: 20,
                fontFamily: 'SimSun',
            },
            fontContent: [{
                key: 'section3.4.20.2.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '在工程实践中，有些场合因不便于尺规绘图而采用了徒手绘图的方法来表示工程对象。请查阅有关资料，了解徒手绘图的应用场合，分析在徒手绘图中需要注意的事项。', // *必填* 文本内容
                textStyle: {
                    color: '#1A1A1A',
                    fontSize: device.isMobile ? 26 : 18,
                    lineHeight: 44,
                    fontFamily: 'SimSun',
                    fontWeight:'bold'
                },
            }, ]
        }, ]
    }, 
    //笔记内容
    {
        key: 'section3.4.21',
        type: "frame",
        shortText: "", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '文旌数字教材', // *必填* 标题文本内容
        category: 'frame_textarea', //
        titleBg: {
            key: 'section3.4.21.1', // *必填* 唯一标识
            src: require("@/assets/images/books/book1/frame_note_titlebg.png"), // *必填* 图片地址
            category: 'frame_titlebg',
            textStyle: {
                width: '100%',
                height: 48,
            },
        },
        content: [{
            key: 'section3.4.21.2', // *必填* 唯一标识
            category: '',
            hasBack: 1, // 是否存在背景 背景默认为白色背景黑色描边 1：存在 2：不存在
            placeholder: '请输入你的笔记',
            value: '',
            titleStyle: {

            }
        }, ]
    },
    // 视频
    {
        key: 'section3.4.22', // *必填* 唯一标识
        type: 'video', // *必填* 类型：视频
        templateType: 1, // *必填* 板式 1：全部显示-平铺 2：两个并列-平铺 3：视频集 4：左右滑动
        styleType: 1, // 使用的样式 1：机械制图中使用的样式 默认为封面+标题
        content: [ // *必填* 视频列表
            {
                key: 'section3.4.22.1', // *必填* 唯一标识
                url: require("@/assets/video/大国工匠2023年度人物——张帅坤.mp4"), // *必填* 视频地址
                left_img: require("@/assets/images/books/bookExample/video-left.png"), // 视频封面
                title: '大国工匠2023年度人物——张帅坤', // 视频标题
                subtitle: '大国工匠2023年度人物——张帅坤', // 视频副标题 只在全部显示时使
                titleStyle: {
                    // 根据需要是否加标题样式
                    // fontFamily: 'xxx', // 字体，本地配置的字体
                    // fontSize: 20, // 文字大小  默认：20
                    // lineHeight: 40, // 行高  默认：36
                    // textIndent: 40, // 首行缩进  默认：40 或者可以使用字节数2em
                    // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
                    // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
                    // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
                    // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
                    // color: '#333', // 文本颜色  默认：#00a8ac
                    // backgroundColor: '#FFF', // 背景颜色  默认：无
                }
            },

        ],
    },
    // 标题
    {
        key: 'section3.4.23',
        type: "title",
        category: 6, // *必填* 分类 1：章头 2：节头 3：小标题 ...
        // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
        //shortText: "二", // 小标题文本，有值的时候展示 例如：第一章、第一节等
        text: '学习成果评价', // *必填* 标题文本内容
        shortTextSize: device.isMobile ? 32 : 28,
        textSize: device.isMobile ? 36 : 30,
        textStyle: {
            // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
            // fontSize: 26, // 文字大小  默认：26
            // lineHeight: 40, // 行高  默认：46
            // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
            // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            // color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
            // backgroundImage: require("@/assets/images/books/book1/subchapter-back.png") // 背景图片  默认：无
        },
    },
    //正文
    {
        key: 'section3.4.24', // *必填* 唯一标识
        type: 'text', // *必填* 类型：正文
        content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
            {
                key: 'section3.4.24.1', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '指导教师根据学生的实际学习成果对其进行评价，学生配合指导教师共同完成如表', // *必填* 文本内容
                textStyle: {


                },
            },
            {
                key: 'section3.4.24.2', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '1-9', // *必填* 文本内容
                textStyle: {
                    fontFamily: 'Times New Roman', // 字体，本地配置的字体
                },
            },
            {
                key: 'section3.4.24.3', // *必填* 唯一标识
                category: 'text', // *必填* 内容类型 text：文本
                text: '所示的学习成果评价表。', // *必填* 文本内容
                textStyle: {


                },
            },
        ],
        textStyle: {
            // fontFamily: 'xxx', // 字体，本地配置的字体
            // fontSize: 20, // 文字大小  默认：20
            // lineHeight: 40, // 行高  默认：36
            textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
            // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
            // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
            // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
            // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
            color: '#333', // 文本颜色  默认：#00a8ac
            // backgroundColor: '#FFF', // 背景颜色  默认：无
        },
    },
    // 图片
    {
        key: 'section3.4.25', // *必填* 唯一标识
        type: 'image', // *必填* 类型：正文
        // info: '高清图片、音视频、三维模型、可交互动态图像……多元视听体验，让学习更具象',
        // cover: require("@/assets/images/bookContent/single_video.png"),
        content: [ // *必填* 图片列表
            {
                key: 'section3.4.25.1', // *必填* 唯一标识
                url: require("@/assets/images/books/book1/chapter1/表1-9学习成果评价表.png"), // *必填* 图片地址
                title: "表<i style=\"font-family:'Times New Roman'; font-style: normal;\">1-9<\/i>  学习成果评价表", // 图片标题
                heightNoLimit: 1,
                titlePosition: 'top', // 标题位置， 默认为bottom
                titleStyle: {

                }
            }
        ],
    },
]
export default content
